import { useDataStore } from "@store/user_org";

/**
 * Demo mode.
 *
 * When the active org is the dev/demo org, all "MBMO" naming and logos are
 * hidden across the app so it can be shown to prospects as a neutral,
 * white-label tool. Demo mode is gated purely on the org id below — it is the
 * same org already used for dev-only controls (see `isDevOrg` checks).
 *
 * The login / reset-password screens render before any org is loaded, so they
 * are neutralised unconditionally (see those screens) rather than via this id.
 */
export const DEMO_ORG_ID = "ur1LXurQw1Fv3KBy8XDI";

/** Full product name shown to normal orgs vs. in demo mode. */
export const APP_NAME = "MBMO Pilot";
export const APP_NAME_DEMO = "Pilot";

/** Bare brand name shown to normal orgs vs. in demo mode. */
export const BRAND_NAME = "MBMO";
export const BRAND_NAME_DEMO = "Pilot";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const BRAND_LOGO: string = require("@assets/photos/mbmo.png");

/** Pure helper — true when the given org id is the demo org. */
export const isDemoOrg = (orgId?: string | null): boolean =>
  orgId === DEMO_ORG_ID;

/** Hook — true when the currently loaded org is the demo org. */
export const useIsDemoMode = (): boolean =>
  useDataStore((s) => isDemoOrg(s.orgData?.id));

/** Hook — the MBMO logo, or `null` in demo mode (hidden). */
export const useBrandLogo = (): string | null =>
  useIsDemoMode() ? null : BRAND_LOGO;

/** Hook — the product name, neutralised in demo mode. */
export const useAppName = (): string =>
  useIsDemoMode() ? APP_NAME_DEMO : APP_NAME;

/** Hook — the bare brand name, neutralised in demo mode. */
export const useBrandName = (): string =>
  useIsDemoMode() ? BRAND_NAME_DEMO : BRAND_NAME;
